import React from 'react';
import styled, { css } from 'styled-components';
import LazyLoadedImg from 'core/components/LazyLoadedImg';
import { getColor } from 'core/utils';
import ContentfulImage, { isContentful } from 'core/components/ContentfulImage';
import PropTypes from 'prop-types';

export const Figure = styled.figure`
	position: relative;
	overflow: hidden;
	background: ${getColor("alto")};

	img {
		display: block;
		width: 100%;
		height: 100%;
		transition: 0.5s;
		transform-origin: center;

		${props => props.$contain ? css`
			object-fit: contain;
			background-color: white;
		` : css`
			object-fit: cover;
		`}

		&:hover, &:active {
			transform: scale(1.05);
		}
	}
`;

// To style style the figure element from the parent element :nailcare:
const FancyHoverImg = ({ $contain, lazy, ...props }) => (
	<Figure $contain={$contain}>
		{
			isContentful(props.src)
				? <ContentfulImage {...props} lazy={lazy} />
				: lazy
					? <LazyLoadedImg {...props} />
					: <img {...props} />
		}
	</Figure>
);

FancyHoverImg.propTypes = {
	lazy: PropTypes.bool,
	$contain: PropTypes.bool,
	src: PropTypes.string,
};

export default FancyHoverImg;
